module.exports = __webpack_public_path__ + "static/media/CalveryLogo.18e63c29.svg";